import api from "../../index";

export const GetAllPaymentGatwaysApi = (params) => api.get(`PaymentGateway/PaymentGatways?${params}`);
export const UpdatePaymentGatwayStatusApi = (PaymentGatewayId, params) => api.post(`PaymentGateway/UpdatePaymentGatewayStatus/${PaymentGatewayId}?${params}`);
export const UpdategetwayApi = (id, data) => api.put(`PaymentGateway/Update-PaymentGetwayById/${id}`, data);
export const GetAllCountryApi = () => api.get('DropDown/GetAll-Country');